import api from "./client";

export async function getSiteSettings() {
  const { data } = await api.get("/api/settings");
  return data.data;
}

export async function updateAccentColor(accentColor) {
  const { data } = await api.put("/api/admin/settings/accent", { accentColor });
  return data.data;
}

export async function updateAtelierGallery(images) {
  const { data } = await api.put("/api/admin/settings/atelier-gallery", { images });
  return data.data;
}

export async function updateShippingSettings(payload) {
  const { data } = await api.put("/api/admin/settings/shipping", payload);
  return data.data;
}
